module.exports = __webpack_public_path__ + "img/noOrder.7a98ee73.png";